import React from "react";
import { useHistory } from "react-router";
import { useRecoilValue } from "recoil";
import { accountDataState } from "../../recoil/account";
import { useQuery } from "../../utils";
import useViewModel from "../../viewModel/base";
import { SearchPharmacys } from "../Pharmacys";
import { Header } from "../shared";
import ImportInventory from "./import-inventory/ImportInventory";
import AdminSearchProduct from "./search-products/AdminSearchProduct";
import StatisticalInventory from "./statistical-inventory/StatisticalInventory";
import StatisticsPricesPharmacies from "./statistics-prices-pharmacies/StatisticsPricesPharmacies";

const AdminDashboard = React.memo(() => {
	const query = useQuery();
	const tabId: string = query.get("dashboardTabId") || "1";
	const history = useHistory();

	const viewModel = useViewModel({
		active: parseInt(tabId)
	})

	const accountInfo = useRecoilValue(accountDataState);

	const updateTab = (e: React.MouseEvent, tab: number) => {
		e.preventDefault();

		history.push(`/admin-dashboard?dashboardTabId=${tab}`)
		viewModel.updateData({ active: tab })
	}

	return <div className='w-100'>
		<Header
			title="Trang chủ"
			subTitle={`Admin ${accountInfo.doctor.mDisplayName}`}
			backTo="/"
			showSideBar
			disableBackTo
		/>
		<div id="admin-menu">
			<div className="container">
				<div className="menu-tabs">
					<a href="/#" className={viewModel.data.active === 1 ? 'active' : ''}
						onClick={(e) => updateTab(e, 1)}>Quản lý kho</a>
					<a href="/#" className={viewModel.data.active === 4 ? 'active' : ''}
						onClick={(e) => updateTab(e, 4)}>Tải kho hàng</a>
					<a href="/#" className={viewModel.data.active === 2 ? 'active' : ''}
						onClick={(e) => updateTab(e, 2)}>Thống kê</a>
					<a href="/#" className={viewModel.data.active === 3 ? 'active' : ''}
						onClick={(e) => updateTab(e, 3)}>CSDL</a>
					<a href="/#" className={viewModel.data.active === 5 ? 'active' : ''}
						onClick={(e) => updateTab(e, 5)}>Thống kê giá & NT</a>
				</div>
			</div>
		</div>
		<div id="main">
			<div className="container">
				{
					viewModel.data.active === 1 &&
					<SearchPharmacys redirectLink="/inventory-dashboard?tab=inventories" />
				}
				{
					viewModel.data.active === 2 &&
					<div className="d-flex justify-content-center align-items-center">
						<StatisticalInventory />
					</div>
				}
				{
					viewModel.data.active === 3 &&
					<AdminSearchProduct />
				}
				{
					viewModel.data.active === 4 &&
					<ImportInventory />
				}
				{
					viewModel.data.active === 5 &&
					<StatisticsPricesPharmacies />
				}
			</div>
		</div>
	</div>


});

export default AdminDashboard;
